/** Grymwyrd 한국어 홈 콘텐츠. */
export const homeKo = {
  'home.heroEyebrow': '살아 숨 쉬는 공포 판타지 세계',
  'home.heroTitle': '황혼의 문턱으로',
  'home.heroBody':
    'Grymwyrd는 빅토리아 고딕 공포의 암흑 세계입니다. 안개에 잠긴 마을 Greywick에는 폐허가 된 탑, 저택의 지하실, 그리고 입에 담을 수 없는 의식들이 숨어 있습니다. 영웅을 창조하고, Cataclysm의 베일을 걷어내며, 잊혀지지 않는 이 세계에 당신의 이름을 새기세요.',
  'home.heroPlayCta': '지금 플레이',
  'home.heroBrowseCta': '백과사전 탐색',
  'home.heroQuickstartPrompt': '아직 준비가 안 되셨나요? 무료 Quickstart를 받으세요',
}
